import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

class MarcaRequest extends CrudRequest {
  static baseUrl() {
    return '/produto-servico/marca';
  }

  static list(queryParams = {}) {
    return httpService.get(`${this.baseUrl()}/list-all`, {
      params: queryParams,
    });
  }

  static get(id) {
    return httpService.get(`${this.baseUrl()}/${id}`);
  }

  static save(payload) {
    return httpService.post(`${this.baseUrl()}/add`, payload);
  }

  static getRegional(regionalId) {
    return httpService.get(
      `${this.baseUrl()}/regional-marca/${regionalId}`,
    );
  }

  static listRegionais(marcaId, params = {}) {
    return httpService.get(
      `${this.baseUrl()}/${marcaId}/regionais`,
      {
        params,
      },
    );
  }
}

export default MarcaRequest;
